import sideImage from "../images/afro-solar/operations-and-maintainance/side-image.webp";

const OperationsAndMaintenance = () => {
  return (
    <div className="container-fluid pt-7" id="operations-&-maintenance">
      <div className="me-13 ms-13">
        <div className="row justify-content-center">
          <div className="col-12 col-md-12 col-lg-6 col-xl-4 p-4">
            <h2 className="fs-56 lh-64 gilroy-bold mb-5">
              OPERATIONS & <span className="text-orange-ryb">MAINTENANCE</span>
            </h2>
            <p className="fs-16 my-4 lh-30 text-align-justify">
              Optimal plant performance in the expert hands of AFRO Solar. The
              fast growing utility-scale PV industry demands well managed
              operation & maintenance (O&M) services to keep plant performance
              at par with the needed expectations as well as applicable
              regulations. As utilities embrace and rely on solar PV
              grid-connected plants for both commercial and industrial
              applications, AFRO Solar has the capabilities as well as
              experience in all aspects of solar plant O&M to help deliver
              optimal power.{" "}
            </p>
            <p className="fs-16 my-4 lh-30 text-align-justify">
              AFRO Solar and its sub-contractors has unmatched experience in
              operating and maintaining large utility scale projects and solar
              rooftops for the last fifteen (15) years. We also offer monitoring
              of hardware and services, based on the solar-log data logger
              platform from Germany.
            </p>
          </div>
          <div className="col-12 col-md-12 col-lg-6 col-xl-4">
            <div className="bg-american-yellow p-4">
              <h3 className="fs-28 gilroy-bold text-white">
                Preventive Maintenance Packages
              </h3>
              <ul className="fs-16">
                <li>Regular cleaning of solar panels0</li>
                <li>Frequent maintenance of thermal-based components</li>
                <li>Yearly service of HT side equipment</li>
                <li>Diagnostic testing for low power production</li>
                <li>Circuit testing</li>
                <li>IV curve tracing</li>
                <li>Thermal imaging</li>
                <li>Earth value measurement</li>
                <li>Retro commissioning</li>
                <li>Data acquisition system check</li>
                <li>Warranty management</li>
              </ul>
            </div>
            <div className="bg-american-yellow p-4 mt-4">
              <h3 className="fs-28 gilroy-bold text-white">
                Uptime Management
              </h3>
              <ul className="fs-16">
                <li>Automatic string level visual alarms</li>
                <li>Real time data collection</li>
                <li>Monitoring energy production (daily basis)</li>
                <li>Effective data interpretation</li>
                <li>Solar Resource Management and Prediction</li>
                <li>PV system monitoring systems</li>
                <li>Trending and Analytics for continuous improvement</li>
                <li>Critical and non-critical reactive repairs</li>
                <li>Spare parts and inventory management</li>
              </ul>
            </div>
          </div>
          <div className="col-12 col-md-12 col-lg-12 text-lg-center col-xl-4 pt-5 pt-xl-0">
            <img
              src={sideImage}
              alt="operation and maintenance"
              className="img-fluid"
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default OperationsAndMaintenance;
